import { PrintCardMenu } from './print-card-menu';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { AssetLibraryType } from '../../enum/dto/asset-library-type.enum';
import { PrintCardSize } from '../../enum/dto/print-card-size.enum';

export class HarlequinPrintCardMenu extends PrintCardMenu {
  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Poppins.SemiBold_600, FONT.Poppins.Bold_700];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/tjo6tqu.css';
  }

  shouldFetchVariantAssets(): boolean {
    return true;
  }

  variantAssetTypeSortOrder(): string[] {
    return [AssetLibraryType.PrimaryBrand, AssetLibraryType.AlternateBrand, AssetLibraryType.Brand];
  }

  getAllowedBadgeCount(): number {
    // This is just for this theme as the address card can only have 2 badges but the business card was designed
    // with 3 badges in mind. The theme was set to 3.
    if (this.sections?.firstOrNull()?.cardSize === PrintCardSize.DefaultSize_AddressCard_1x3) {
      return 2;
    }
    return super.getAllowedBadgeCount();
  }
}
